import React, { useCallback, useState } from 'react';
import { PLATFORM_ROOT } from '@zapier/product-dev-platform/src/constants';
import Layout from './components/Layout';
import { HeaderNav, HeaderUser } from '@zapier/product-dev-platform/src/types';
import type { NavItem } from './components/types';

type HeaderProps = {
  /** Links that appear on the right side of the header */
  ctaLinks?: Array<NavItem>;

  /** The curent URL of the page. */
  currentUrl: string;

  /** Link to be used in the logo image */
  logoUrl?: string;

  /** Main links that appear on the left side of the header */
  navLinks?: Array<NavItem>;

  /** Location of the website url */
  urlPath?: string;

  /** The current user's name and avatarUrl */
  user?: HeaderUser;

  /** Links that appear when clicking on the user's avatar */
  userLinks?: Array<NavItem>;
};

const platformPath = (subPath: string) => `${PLATFORM_ROOT}/${subPath}`;

const HEADER_NAV_USER_LINKS: HeaderNav = [
  {
    label: 'How to Build',
    href: platformPath('how-to-build'),
  },
  {
    label: 'Partner Program',
    href: platformPath('partner-program'),
  },
  {
    label: 'Documentation',
    href: 'https://platform.zapier.com/docs',
  },
];
const CTA_LINKS: HeaderNav = [
  {
    label: 'My Integrations',
    href: '/app/developer',
  },
  {
    label: 'Zap Templates',
    href: '/developer/zap-templates/',
  },
];

const USER_LINKS = [
  {
    label: 'Settings',
    href: '/app/developer/partner-settings',
  },
];

const isLinkActive = (currentUrl: string) => (
  link: typeof HEADER_NAV_USER_LINKS[0]
) => (link.href === currentUrl ? { ...link, isActive: true } : link);
/**
 * Platform branded header.
 *
 * *Note: for best results view this component in fullpage mode.*
 */

const Header = ({
  currentUrl,
  ctaLinks = CTA_LINKS,
  logoUrl,
  navLinks = HEADER_NAV_USER_LINKS,
  user,
  userLinks = USER_LINKS,
  urlPath,
}: HeaderProps) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isUserOptsOpen, setUserOptsOpen] = useState(false);
  const toggleNav = useCallback(() => setIsNavOpen(val => !val), []);
  const toggleUserOptions = useCallback(() => setUserOptsOpen(val => !val), []);
  const activeLinkCheck = isLinkActive(currentUrl);

  return (
    <Layout
      ctaLinks={ctaLinks.map(activeLinkCheck)}
      isNavOpen={isNavOpen}
      isUserOptionsOpen={isUserOptsOpen}
      logoUrl={logoUrl}
      nav={navLinks.map(activeLinkCheck)}
      onToggleNav={toggleNav}
      onToggleUserOptions={toggleUserOptions}
      urlPath={urlPath}
      user={user}
      userLinks={userLinks}
    />
  );
};

export default Header;
